import { Injectable } from '@angular/core';
import { FetchHelper } from '../../core/helpers/fetch-helper';
import { Constant } from '../../core/configs/constant';

@Injectable({
  providedIn: 'root',
})
export class TableDynamicService {
  getAllTableDynamic(categoryId: string) {
    return FetchHelper.get(Constant.DYNAMIC_TABLE.GET_LIST, {
      categoryId,
    });
  }
}
